/**
 * Created by jack.gill on 22/11/2017.
 */
var JumpGameEnemy = function (enemiesArray, showHitBoxes) {
    PIXI.Container.call(this);
    this.enemiesArray = enemiesArray;
    this.destroyed = false;
    this.visible = false;
    this.enable = false;
    this.points = 0;
    this.graphic = CC.Utility.pixiSprite(this.enemiesArray[0].texture);
    this.showHitBoxes = showHitBoxes;
    this.addChild(this.graphic);
};

JumpGameEnemy.prototype = Object.create(PIXI.Container.prototype);
JumpGameEnemy.prototype.constructor = JumpGameEnemy;

JumpGameEnemy.prototype.checkHit = function (player) {
    var testDistance = CC.Geometry.vectorDistanceSquared(player, this);
    return testDistance < 50 * 50 && this.enable;
};

JumpGameEnemy.prototype.collect = function () {
    this.enable = false;
    TweenLite.to(this.graphic, 0.2, {alpha: 0});
    TweenLite.to(this.graphic.scale, 0.2, {x: 2, y: 2, onComplete: this.hide.bind(this)});
};

JumpGameEnemy.prototype.show = function (platform, type) {

    TweenLite.killTweensOf(this.graphic);
    this.type = type;
    this.graphic.alpha = 1;
    this.enable = true;
    this.graphic.scale.x = 1;
    this.graphic.scale.y = 1;
    this.destroyed = false;
    this.invincible = this.enemiesArray[this.type].invincible;

    this.graphic.texture = PIXI.Texture.fromFrame(this.enemiesArray[this.type].texture);

    if (this.destroyedGraphic) {
        this.removeChild(this.destroyedGraphic);
        this.destroyedGraphic = undefined;
    }
    if (this.enemiesArray[this.type].destroyed_graphic) {
        this.destroyedGraphic = Widgets.createAsset(this.enemiesArray[this.type].destroyed_graphic);
        this.destroyedGraphic.alpha = 0;
        this.addChild(this.destroyedGraphic);
    }

    if (this.hitGraphic) {
        this.removeChild(this.hitGraphic);
        this.hitGraphic = undefined;
    }

    this.hitGraphic = new PIXI.Graphics();
    this.hitGraphic.lineStyle(4, 0x000000, 1);
    this.hitGraphic.beginFill(0x339966, 0.5);

    if (this.enemiesArray[this.type].hit_box && this.enemiesArray[this.type].hit_box.width &&
        this.enemiesArray[this.type].hit_box.height) {

        this.hitGraphic.drawRect(
            this.enemiesArray[this.type].hit_box.width * -0.5,
            this.enemiesArray[this.type].hit_box.height * -0.5,
            this.enemiesArray[this.type].hit_box.width,
            this.enemiesArray[this.type].hit_box.height);

        if (this.enemiesArray[this.type].hit_box.position) {
            this.hitGraphic.position = this.enemiesArray[this.type].hit_box.position;
        }

    }
    else {
        this.hitGraphic.drawRect(
            this.graphic.width * -0.5,
            this.graphic.height * -0.5,
            this.graphic.width,
            this.graphic.height);
    }

    this.hitGraphic.endFill();
    this.hitGraphic.visible = !!this.showHitBoxes;
    this.graphic.addChild(this.hitGraphic);

    this.visible = true;
    this.targetPlatform = platform;
    this.x = this.targetPlatform.x;
    this.halfHeight = this.graphic.height / 2;
    this.y = this.targetPlatform.y - (this.graphic.height * this.graphic.anchor.y);

};

JumpGameEnemy.prototype.hide = function () {

    if (this.destroyedGraphic) {
        this.destroyed = true;
        this.graphic.alpha = 0;
        this.destroyedGraphic.alpha = 1;

        TweenLite.to(this.destroyedGraphic, 1, {
            alpha: 0,
            onComplete: function () {
                this.graphic.alpha = 1;
                this.visible = false;
                this.enable = false;
            }.bind(this)
        });
    }
    else {
        this.destroyed = true;
        this.graphic.alpha = 1;
        this.visible = false;
        this.enable = false;
    }

};